import { Fragment } from 'react'

import { PaymentDetails } from './components'

import { Divider, HighlightTitle } from '..'

import {
  PAYMENT_DETAILS_EXAMPLE,
  PAYMENT_DETAILS_EXAMPLE_MODIFIED_RESULT,
  PAYMENT_DETAILS_EXAMPLE_UNMODIFIED_RESULT
} from './constants'

import styles from './PaymentExample.module.scss'

export const PaymentExample = () => {
  return (
    <div className={styles.paymentExample}>
      <div>
        <div className={styles.paymentExample__hired}>
          <p className={styles.paymentExample__text}>Exemplo:</p>

          {PAYMENT_DETAILS_EXAMPLE.map(({ icon, text }, index) => (
            <Fragment key={`payment-example-${index}`}>
              <HighlightTitle icon={icon} text={<b>{text}</b>} />

              {index === 1 && <Divider />}
            </Fragment>
          ))}
        </div>

        <div className={styles.paymentExample__result}>
          <PaymentDetails
            text="0 à 09 Consultas"
            paymentData={PAYMENT_DETAILS_EXAMPLE_UNMODIFIED_RESULT}
          />

          <PaymentDetails
            text="13 Consultas"
            paymentData={PAYMENT_DETAILS_EXAMPLE_MODIFIED_RESULT}
          />
        </div>
      </div>
    </div>
  )
}
